import React, {useState, useEffect, useRef } from 'react';
import { FiArrowUp, FiArrowDown, FiInfo } from "react-icons/fi";
import { useDispatch, useSelector } from 'react-redux';
import Loader from "react-loader-spinner";
import { useTranslation } from "react-i18next";
import * as jobsActions from '../../Redux/Actions/jobs';
import * as allMasterProcess from '../../Redux/Actions/masterProcess';
import * as allProcess from '../../Redux/Actions/process';
import {toastMessage} from '../../utils/toast';
import { useSortableData } from '../../utils/sortableData';
import { clearSession } from '../../utils/initiate';
import { getParams, dateTimeFormat, useOnClickOutside } from '../../utils';
import Warning from '../Ui/400';
import ReactPaginate from 'react-paginate';
import '../../assets/table.css';
import DropDown from '../Ui/DropDown';
import DataCount from '../../utils/dataCount';

const JobsSLA = ({history}) => {

    let itemsPerPage = 10;
    const [data, setData] = useState([]);
    const [type, setType] = useState('');
    const [statusList, setStatusList] = useState([]);
    const [statusList_2, setStatusList_2] = useState([]);
    const [jobSelectedStatus, setJobSelectedStatus] = useState('');
    const [filterID, setFilterID] = useState('');
    const [masterProcess, setMasterProcess] = useState('');
    const [process, setProcess] = useState('');
    const [filterFromDate, setFilterFromDate] = useState('');
    const [filterToDate, setFilterToDate] = useState('');
    const [loading, setLoading] = useState(false);
    const [loading1, setLoading1] = useState(false);
    const [errStatus, setErrStatus] = useState(200);
    const dispatch = useDispatch();
    const [currentItems, setCurrentItems] = useState([]);
    const [pageCount, setPageCount] = useState(0);
    const [itemOffset, setItemOffset] = useState(0);
    const { t } = useTranslation();
    const [masterProcessList, setMasterProcessList] = useState([]);
    const [processList, setProcessList] = useState([]);
    const [breachedTimeOption, setBreachedTimeOption] = useState([]); 
    const [autoRefreshOption, setAutoRefreshOption] = useState([]); 
    const [selectedbreachedTime, setSelectedbreachedTime] = useState(''); 
    const [selectedAutoRefreshedTime, setSelectedAutoRefreshedTime] = useState('');
    const [breachedStatus, setBreachedStatus] = useState(true);
    const [activeStatus, setActiveStatus] = useState(true);
    const [autoIntervalInMilliSec, setAutoIntervalInMilliSec] = useState(0);
    const [filter, setFilter] = useState(0);
    const userData = useSelector(({ User }) => User.data);

    // let params = getParams(window.location.search);
    const ref = useRef();

    useEffect(() => {
        setBreachedTimeOption([
            { lable: "15 Minutes", value: "15" },
            { lable: "30 Minutes", value: "30" },
            { lable: "45 Minutes", value: "45" },
            { lable: "1 Hours", value: "60" },
        ]);
        setAutoRefreshOption([
            { lable: "Off", value: "0" },
            { lable: "5 Seconds", value: "5" },
            { lable: "10 Seconds", value: "10" },
            { lable: "20 Seconds", value: "20" },
            { lable: "30 Seconds", value: "30" },
            { lable: "60 Seconds", value: "60" },
        ]);
        handleGetJobStatuses();
        handleGetAllMasterProcess();
        handleGetAllProcess();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(()=>{
        if(userData.Role === 'SUBADMIN') {
            let status = statusList.filter(({value}) => value === 'AssignedToTypingCenter' || value === 'AwaitingResponse' || value === 'RequestCancellation' || value === 'RequestCompletion');
            setStatusList_2(status);
        } else {
            setStatusList_2(statusList);
        }
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [statusList]);

    const handleGetAllJobs = () => {
        setLoading1(true);
        let payload = {
            jobId: filterID,
            masterProcessId: masterProcess.value,
            processId: process.value,
            jobStatus: jobSelectedStatus,
            fromDate: filterFromDate,
            toDate: filterToDate,
            breachedStatus: breachedStatus,
            breachedTime: selectedbreachedTime,
            isActive: activeStatus, 
        };
        jobsActions.getAllSla(payload).then(res => {
            if(res && res.data){
                let jobData = [];
                res.data.map((form, index) => jobData.push({'sno': index+1, ...form}));
                setData(jobData);
            }else{
                setData([]);
                toastMessage('error', (res && res.message) || `Unable to load the jobs`);
            }
            setLoading1(false);
            setType('');
        }).catch(err => {
            setErrStatus(err.response.status);
            (err.response.status === 401) && clearSession(dispatch, history);
        });
    };

    const {items, requestSort, sortConfig} = useSortableData(data);
    
    useEffect(() => {
        const endOffset = itemOffset + itemsPerPage;
        setCurrentItems(items.slice(itemOffset, endOffset));
        setPageCount(Math.ceil(items.length / itemsPerPage));
    }, [itemOffset, itemsPerPage, items, jobSelectedStatus]);

    const handlePageClick = (event) => {
        const newOffset = event.selected * itemsPerPage % data.length;
        setItemOffset(newOffset);
    };

    const handleGetJobStatuses = () => {
        jobsActions.getAllJobStatuses().then(({data}) => {
            if(data){
                let statusDetails = data.filter(({value}) => value !== 'Payment');
                setStatusList(statusDetails);
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || `Unable to get the job statuses`);
        });
    };

    const handleGetAllMasterProcess = () => {
        allMasterProcess.getAll().then(({data}) => {
            if(data){
                let masterProcessList = data;
                masterProcessList = masterProcessList.map(({id, name}) => ({"label": name, "value": id}));
                setMasterProcessList(masterProcessList);
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || `Unable to get the master process`);
        });
    }

    const handleGetAllProcess = () => {
        allProcess.getAll().then(({data}) => {
            if(data){
                let processList = data;
                processList = processList.map(({id, description}) => ({"label": description, "value": id}));
                setProcessList(processList);
            }
        }).catch(err => {
            toastMessage('error', (err && err.message) || `Unable to get the process`);
        });
    }

    const handleClearFilter = () => {
        setJobSelectedStatus(''); 
        setFilterID('');
        setMasterProcess('');
        setProcess('');
        setFilterFromDate('');  
        setFilterToDate('');
        setSelectedbreachedTime('');
        setFilter(0);
    }

    const filterHandler = () => {
        if(jobSelectedStatus || filterID || masterProcess.value || process.value || filterFromDate || filterToDate || selectedbreachedTime) {
           setFilter(filter + 1);
        } 
    }

    useEffect(() => {
        handleGetAllJobs();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [filter, breachedStatus, activeStatus]);

    const handlePageRefresh = (Seconds) => {
        var milliSeconds = Seconds * 1000;
        setAutoIntervalInMilliSec(milliSeconds);
    }

    
    useEffect(() => { //This useEffect for Auto Refresh
        if(autoIntervalInMilliSec !== 0 ){
            const interval = setInterval(() => {
                // console.log(`This will be called every ${autoIntervalInMilliSec/1000} seconds`);
                handleGetAllJobs();
              }, autoIntervalInMilliSec);
            
              return () => clearInterval(interval);
        }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [selectedAutoRefreshedTime, jobSelectedStatus, filterID, masterProcess, process, filterFromDate, filterToDate, selectedbreachedTime, breachedStatus, activeStatus]);

    if(errStatus === 400){
        return <Warning history={history} />
    }
   
    return(
        <>
            {(type === '') && <div className="container-fluid">
                <div className="page-title-box">
                    <h4 className="page-title my-2">{t("jobSla.manageJobsSla.title")}</h4>
                </div>
                <div className="row">
                    <div className="col-lg-12 col-xxl-12">
                        <div className="card card-custom card-stretch gutter-b">
                            <div className="card-body py-3">
                                <div className="tab-content">
                                    <div className="d-flex align-items-center justify-content-between">
                                        <div className="d-flex" style={{width:'100%'}}>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobSla.filters.labelJobID")}</label>
                                                <input placeholder={t("jobSla.filters.enterID")} type="number" className="form-control me-3" style={{height:'37px'}} name="Filter ID" value={filterID} onChange={e => setFilterID(e.target.value)}  />
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <DropDown isSearchable={true} label={t("jobSla.filters.labelMasterProcess")} placeholder={t("jobSla.filters.selectMasterProcess")} options={masterProcessList} value={masterProcess} onChange={(value) => setMasterProcess(value)} />
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <DropDown isSearchable={true} label={t("jobSla.filters.labelprocess")} placeholder={t("jobSla.filters.selectprocess")} options={processList} value={process} onChange={(value) => setProcess(value)} />
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobSla.filters.labelJobStatus")}</label>
                                                <select className="form-select me-3" style={{height:'37px'}} value={jobSelectedStatus} onChange={e => setJobSelectedStatus(e.target.value)}>
                                                    <option value="" disabled={true}>{t("jobSla.filters.selectJobStatus")}</option>
                                                    {statusList_2.map(({lable, value}) => <option key={value} value={value}>{lable}</option>)}
                                                </select>
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobSla.filters.breachedTime")}</label>
                                                <select className="form-select me-3" style={{height:'37px'}} value={selectedbreachedTime} onChange={e => setSelectedbreachedTime(e.target.value)}>
                                                    <option value="" disabled={true}>{t("jobSla.filters.selectBreachedTime")}</option>
                                                    {breachedTimeOption.map(({lable, value}) => <option key={value} value={value}>{lable}</option>)}
                                                </select> 
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <div className="d-flex">
                                                    <div className="form-switch form-switch-secondary">
                                                        <input className="form-check-input background-color-red" style={{height:'20px', width:'40px', backgroundColor: (breachedStatus ? 'green' : '')}} type="checkbox" checked={breachedStatus} onChange={() => {setBreachedStatus(!breachedStatus);}} />
                                                    </div>
                                                    <label dir="rtl" className="my-1 ms-2 me-3">{t("jobSla.filters.breachedList")}</label>
                                                </div>
                                                {userData.Role === 'SUPERADMIN' && <div className="d-flex">
                                                    <div className="float-end  form-switch form-switch-secondary">
                                                        <input className=" form-check-input background-color-red" style={{height:'20px', width:'40px', backgroundColor: (!activeStatus ? 'green' : '')}} type="checkbox" checked={!activeStatus} onChange={() => {setActiveStatus(!activeStatus);}} />
                                                    </div>
                                                    <label dir="rtl" className="my-1 ms-2">{t("jobSla.filters.inActiveList")}</label>
                                                </div>}    
                                            </div>
                                        </div>
                                    </div>
                                    <div className="d-flex align-items-center justify-content-between mb-3">
                                        <div className="d-flex" style={{width:'49.5%'}}>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobSla.filters.LabelFromDate")}</label>
                                                <input type="date" className="form-control me-3" name="From Date" value={filterFromDate} onChange={e => setFilterFromDate(e.target.value)}/>
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobSla.filters.LabelToDate")}</label>
                                                <input type="date" disabled={filterFromDate === '' ? true : false} min={filterFromDate} className="form-control me-3" value={filterToDate} onChange={e => setFilterToDate(e.target.value)} />
                                            </div>
                                            <div className="d-flex align-items-end" style={{whiteSpace: 'nowrap'}}>
                                                <button onClick={filterHandler} type="button" className="d-flex me-3 px-4 align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.filter")}</button>
                                            </div>
                                            <div className=" d-flex align-items-end" style={{width:'100%', whiteSpace: 'nowrap'}}>
                                                <button onClick={e => handleClearFilter()}type="button" className="px-5 d-flex align-items-center btn btn-primary font-weight-bold" >{t("jobsManagement.filters.clearFilters")}</button>
                                            </div>
                                        </div>
                                        {/* Auto Refresh ------------------------------------------------------------------------------------------------ */}
                                        <div className="d-flex" style={{width:'21%'}}>
                                            <div className="me-3 mt-3" >
                                            {loading1 ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40}/> : <Loader type="ThreeDots" color="#FFFFFF" height={40} width={40}/>}
                                            </div>
                                            <div className="me-3" style={{width:'100%'}}>
                                                <label className="mb-1 ms-1 me-3">{t("jobSla.filters.autoRefresh")}</label>
                                                <select className="form-select me-3" value={selectedAutoRefreshedTime} onChange={e => {handlePageRefresh(e.target.value); setSelectedAutoRefreshedTime(e.target.value);}}>
                                                    {autoRefreshOption.map(({lable, value}) => <option key={value} value={value}>{lable}</option>)}
                                                </select>
                                            </div>
                                        </div>
                                    </div>
                                    {loading ? <Loader type="ThreeDots" color="#ad1a5f" height={40} width={40} style={{textAlign: 'center', marginBottom: '50px'}} />
                                        : <div className="table-responsive" style={{width: '100%', overflowX:'scroll'}}>
                                        <table className="table tableFreez tablefix table-head-custom table-vertical-center table-head-bg">
                                            <thead>
                                                <tr className="text-left" >
                                                    <th className="c-pointer pl-7" style={{width: '60px'}} onClick={() => requestSort('sno')}>
                                                        <span className={(sortConfig && (sortConfig.key === 'sno')) ? "text-primary" : "text-dark-75"}>{t("jobSla.manageJobsSla.sNo")} {(sortConfig && (sortConfig.key === 'sno')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span>
                                                    </th>
                                                    <th className="c-pointer" style={{width: '75px'}} onClick={() => requestSort('id')}><span className={(sortConfig && (sortConfig.key === 'id')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.id")} {(sortConfig && (sortConfig.key === 'id')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('masterProcess')}><span className={(sortConfig && (sortConfig.key === 'masterProcess')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.masterProcess")} {(sortConfig && (sortConfig.key === 'masterProcess')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('process')}><span className={(sortConfig && (sortConfig.key === 'process')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.process")} {(sortConfig && (sortConfig.key === 'process')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('processCostName')}><span className={(sortConfig && (sortConfig.key === 'processCostName')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.processCostName")} {(sortConfig && (sortConfig.key === 'processCostName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '150px'}} onClick={() => requestSort('jobStatus')}><span className={(sortConfig && (sortConfig.key === 'jobStatus')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.jobStatus")} {(sortConfig && (sortConfig.key === 'jobStatus')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{width: '200px'}} onClick={() => requestSort('agentName')}><span className={(sortConfig && (sortConfig.key === 'agentName')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.agentName")} {(sortConfig && (sortConfig.key === 'agentName')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{textAlign: 'center',width: '200px'}} onClick={() => requestSort('eventStartTime')}><span className={(sortConfig && (sortConfig.key === 'eventStartTime')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.eventStartTime")} {(sortConfig && (sortConfig.key === 'eventStartTime')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{textAlign: 'center',width: '200px'}} onClick={() => requestSort('eventCompletionTime')}><span className={(sortConfig && (sortConfig.key === 'eventCompletionTime')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.eventCompletionTime")} {(sortConfig && (sortConfig.key === 'eventCompletionTime')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                    <th className="c-pointer" style={{textAlign: 'center',width: '200px'}} onClick={() => requestSort('spentTime')}><span className={(sortConfig && (sortConfig.key === 'spentTime')) ? "text-secondary" : "text-dark-75"}>{t("jobSla.manageJobsSla.spentTime")} {(sortConfig && (sortConfig.key === 'spentTime')) && ((sortConfig.direction === 'ascending') ? <FiArrowUp /> : <FiArrowDown />)}</span></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {currentItems.map(({sno, masterProcess, process, processCostDetailName, job, agent, eventStartTime, spentTime, eventCompleteTime}) => {
                                                    return(
                                                        <tr key={sno}>
                                                            <td className="pl-7">
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{sno}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{ cursor: 'pointer'}} onClick={() => history.push(`/customer_job_reports/${job.id}`)}>{job.id}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{masterProcess.name}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{process.name}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{processCostDetailName}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{job.status}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg">{agent.name}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign:  'center'}}>{eventStartTime ? dateTimeFormat(eventStartTime) : '-'}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{eventCompleteTime ? dateTimeFormat(eventCompleteTime) : '-'}</span>
                                                            </td>
                                                            <td>
                                                                <span className="text-dark-75 font-weight-bolder d-block font-size-lg" style={{textAlign: 'center'}}>{spentTime === "   " ? '-' : spentTime}</span>
                                                            </td>
                                                        </tr>
                                                    )})}
                                            </tbody>
                                        </table>
                                        {(pageCount > 1) && <ReactPaginate
                                            breakLabel="..."
                                            nextLabel=">"
                                            previousLabel="<"
                                            onPageChange={handlePageClick}
                                            pageRangeDisplayed={5}
                                            pageCount={pageCount}
                                            pageClassName="page-item"
                                            pageLinkClassName="page-link"
                                            previousClassName="page-item"
                                            previousLinkClassName="page-link"
                                            nextClassName="page-item"
                                            nextLinkClassName="page-link"
                                            breakClassName="page-item"
                                            breakLinkClassName="page-link"
                                            containerClassName="pagination"
                                            activeClassName="active"
                                            renderOnZeroPageCount={null}
                                        />}
                                        {(data.length === 0) && <p className="text-center mt-5 mb-5">{t("jobsManagement.noDataAvailable")}</p>}
                                    </div>}
                                    {data.length>0 && <DataCount itemOffset={itemOffset} items={items}/>}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </>
    );
};

export default JobsSLA;